module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  total=\"$ctrl.total\"\n  limit=\"$ctrl.limit\"\n  item-state=\"pricing\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  resource=\"PrivateBusPricing\"\n  title=\"Pricings\"\n  transformer=\"PricingsTransforms\"\n  no-items-text=\"No Private Bus Pricing Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/pricings/pricings.html
// module id = 1949
// module chunks = 0